import React from "react";
import { motion } from "framer-motion";
import { BuyButton } from "./BuyButton";
import { Stars } from "./Stars";
import { TestimonialCarousel } from "./TestimonialCarousel";
import { IMAGES, scrollToBuy } from "../lib/data";
const chips = ["📄 100% PDF", "⚡️ Entrega Inmediata", "📦 25 Plantillas + Bonos + 3 Ebooks de casos clínicos"];
export function Hero() {
  return <section className="px-4 pt-8" data-id="element-97" data-mp="1297bo2fk8x8s">
      <div className="mx-auto max-w-md" data-id="element-98" data-mp="128fo9ew4a5tl">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="font-display text-[26px] font-extrabold leading-[1.15] text-slate-900" data-id="element-99" data-mp="1274odq5sli7r">
          El sistema que te devuelve{" "}
          <span className="text-teal-600" data-id="element-100" data-mp="neaw145f97lo">10 horas a la semana</span> sin dejar de
          atender ni un paciente
        </motion.h1>

        <motion.button type="button" onClick={scrollToBuy} initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mt-5 block w-full" aria-label="Ver el megapack — ir a comprar" data-id="element-101" data-mp="382p5jcx17dl5">
          <img src={IMAGES.product} alt="Megapack Fisio Eficiente — caja de producto con plantillas, checklists y bonos" className="h-auto w-full mix-blend-multiply drop-shadow-xl" data-id="element-102" data-mp="399bc1q3avhx1" />
        </motion.button>

        <p className="mt-5 text-[15px] leading-relaxed text-slate-600" data-id="element-103" data-mp="358rckfv9827q">
          Más de <strong className="text-slate-800" data-id="element-104" data-mp="35aucbrm7l9pn">25 plantillas, Excel y checklists</strong>{" "}
          listos para usar — evaluación, historia clínica, escalas de valoración,
          seguimiento de pacientes y control de bonos, todo en un solo pack para que
          tu consulta funcione sola.
        </p>

        <div className="mt-4 flex flex-wrap gap-2" data-id="element-105" data-mp="2hlj7nz1qmv68">
          {chips.map(c => <span key={c} className="rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 shadow-sm" data-id="element-106" data-mp="2ljz0wkoewzs3">
              {c}
            </span>)}
        </div>

        <div className="mt-6" data-id="element-107" data-mp="ibp0grdbiyxj">
          <BuyButton data-id="element-108" data-mp="id00cg3n7mjd" />
        </div>

        <div className="mt-4 flex items-center justify-center gap-2 text-sm" data-id="element-109" data-mp="i9vp4yrrfqj7">
          <span className="font-bold text-slate-800" data-id="element-110" data-mp="deyjm1tovzb2">+450 fisioterapeutas</span>
          <Stars size={15} data-id="element-111" data-mp="1azkqjd8dtslc" />
          <span className="font-bold text-slate-800" data-id="element-112" data-mp="1ayt68yk8jhad">4.9/5</span>
        </div>

        <TestimonialCarousel data-id="element-113" data-mp="162ccnou9oapw" />
      </div>
    </section>;
}